<template>
  <v-data-table :headers="headers" :items="items" group-by="week" hide-default-footer hide-default-header
    disable-pagination>
    <template v-slot:group.header="{ items, isOpen, group, toggle }">
      <td :colspan="headers.length + 2" class="group-header">
        <h3>
          {{ $t('message.dispoc.week', { value: 'default' }) }} {{ group }}
          <v-btn icon @click="toggle">
            <v-icon>{{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-btn>
        </h3>
      </td>
    </template>

    <template v-slot:header="{ props: { headers } }">
      <th v-for="(h, idx) in headers" :key="idx" :width="h.width">
        <div>
          <span>{{ h.locomotive || h.text }}</span><br />
          <small>{{ h.ecm || '' }}</small><br />
          <small>{{ h.lstatus || '' }}</small>
        </div>
      </th>
      <th :width="'150px'">{{ $t('message.dispoc.locDisp', { value: 'default' }) }}</th>
      <th :width="'150px'">{{ $t('message.dispoc.locTot', { value: 'default' }) }}</th>
    </template>

    <template v-slot:item="{ item }">
      <tr>
        <td v-for="(h, cidx) in headers" :key="cidx" class="cell-text-center" @click.stop="onCellClick(item, h.value)">
          <!-- Date column -->
          <span v-if="h.value === 'day'">{{ item.day }}</span>
          <!-- Data cells -->
          <span v-else-if="item[h.value] && item[h.value].countable" class="chip" :class="item[h.value].ind">
            {{ item[h.value].ind }}
          </span>
        </td>
        <!-- colonne disponibilité et total -->
        <td class="cell-text-center">
          {{ calculateDispo(item) }}
        </td>
        <td class="cell-text-center">
          {{ countCountable(item) }}
        </td>
      </tr>
    </template>
    <template v-slot:body.append>
      <tr style="border-bottom: 1px solid #000;">
        <th colspan="100">
          <h2>{{ $t("message.dispoc.taux", { value: "default" }) }}</h2>
        </th>
      </tr>
      <tr>
        <td>
          <h4>{{ $t("message.dispoc.recapLoc", { value: "default" }) }}</h4>
        </td>
        <td class="cell-text-center  font-weight-bold" v-for="(item, idx) in mcRate" :key="idx">{{ ipercent(item) }}
        </td>
        <td class="cell-text-center" colspan="2"></td>
      </tr>
      <tr>
        <td>
          <h4>{{ $t("message.dispoc.ticmp", { value: "default" }) }}</h4>
        </td>
        <td class="cell-text-center font-weight-bold" v-for="(item, idx) in pmRate" :key="idx">{{ percent(item) }}</td>
        <td class="cell-text-center" colspan="2"></td>
      </tr>
      <tr>
        <td>
          <h4>{{ $t("message.dispoc.timcc", { value: "default" }) }}</h4>
        </td>
        <td class="cell-text-center font-weight-bold" v-for="(item, idx) in mcRate" :key="idx">{{ percent(item) }}</td>
        <td class="cell-text-center" colspan="2"></td>
      </tr>
      <tr>
        <td>
          <h4>{{ $t("message.dispoc.ticc", { value: "default" }) }}</h4>
        </td>
        <td class="cell-text-center font-weight-bold" v-for="(item, idx) in mccRate" :key="idx">{{ percent(item) }}</td>
        <td class="cell-text-center" colspan="2"></td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'AvailabilityTable',
  props: {
    headers: Array,
    items: Array,
    assets: Array,
    mcRate: Array,
    mccRate: Array,
    pmRate: Array

  },
  methods: {
    onCellClick(item, key) {
      this.$emit('cell-click', { item, key });
    },
    calculateDispo(item) {
      return Object.values(item)
        .filter(v => v.countable && v.ind !== 'B2')
        .length;
    },
    countCountable(item) {
      return Object.values(item)
        .filter(v => v.countable)
        .length;
    },

    percent(item) {
      return Math.round(this.zeroDiv(item.rate, item.days) * 100) + " %"
    },

    zeroDiv(n1, n2) {
      if (n2 == 0) {
        return 0
      }
      return n1 / n2
    },

    ipercent(item) {
      return Math.round(100 - this.zeroDiv(item.rate, item.days) * 100) + " %"
    },
  }
};
</script>

<style scoped>
.group-header {
  background-color: #f0f1f5;
}

.cell-text-center {
  text-align: center;
}
</style>